module.exports = __webpack_public_path__ + "/images/cover-regalos-facil.4650fb5.svg";